export default {
      id: "icon-instagram-usage",
      viewBox: "0 0 169.063 169.063",
      url: __webpack_public_path__ + "icons.svg#icon-instagram",
      toString: function () {
        return this.url;
      }
    }